import getDefaultLocale from '~/utils/locale/getDefaultLocale'

export default defineNuxtPlugin(async () => {
  const i18n = useI18n()
  const languageManager = LanguageManager()
  const detectLocale = useDetectLocale()
  const locale = useState<string>('locale.setting', () => getDefaultLocale().iso)
  locale.value = await detectLocale.getLocale()

  if (!Object.keys(i18n.translationStore.getResources || {}).length) {
    await i18n.initClientTranslations()
  }

  await languageManager.setLocaleData(locale.value)
})
